import _ from 'lodash';
import uuid4 from 'uuid/v4';
import {selectUnsuccessfulBackendCalls} from 'ducks/notifications';

// If an action throws 500 more than 3 times - it's considered to be constantly unsuccessful
const CONSTANTLY_UNSUCCESSFUL_THRESHOLD = 3;

export const isActionConstantlyUnsuccessful = (state, action) => {
  const failedBackendCalls = selectUnsuccessfulBackendCalls(state);

  const failedBackendCall = _.head(
    failedBackendCalls.filter(
      failedCall => failedCall.actionType == action.type
    )
  );

  if (!failedBackendCall) {
    return false;
  }

  return (
    failedBackendCall.occurrencesCounter >= CONSTANTLY_UNSUCCESSFUL_THRESHOLD
  );
};

export const getBlockedActionToastObject = () => {
  const uuid = uuid4();
  const title = 'Action Blocked';
  const text = `
  It seems like the action you are trying to do is failing too many times!
  This is likely a bug in the system.
  We have been notified of this incident and we are working hard on fixing it.
  Apologies for the inconvenience.`;

  return {uuid, title, text, color: 'red'};
};
